import { schema } from 'normalizr';

export const application = new schema.Entity('applications');
export const applications = new schema.Array(application);
